module.exports = __webpack_public_path__ + "img/lang-7.c0620b3c.jpg";